export const readmsg = {
    data() {
        return {
            readmsg_disabled: 1,
            detail_show: false,
        }
    },
    methods: {
        yin_detail() {
            this.detail_show = false;

        },
        //详细信息
        detail_click_show() {
            this.detail_show = true;
        },
        // 排序
        sortChangeEvent({ prop, order }) {
            console.log(prop, order);
            if (prop == 'AC_DATE') {
                prop = 'datetime';
            } else if (prop == 'IP') {
                prop = 'peerip';
            } else if (prop == 'ENVFROM') {
                prop = "envfrom";
            } else if (prop == 'ENVRCPT') {
                prop = 'envrcpt';
            } else if (prop == 'SUBJECT') {
                prop = 'subject';
            } else if (prop == 'SIZE') {
                prop = 'msgsize';
            }
            if (order == 'descending') {
                order = "desc";
            } else if (order == 'ascending') {
                order = "asc";
            }
            this.col.q_order_sort = order; // 排序方式
            this.col.q_order_type = prop; // 排序条件
            this.col.startdate = this.date_type //清空时间
            this.tanSend();
        },
        // 显示摘要
        abstract_show_tow_database() {
            this.readmsg_disabled = 0
            const close_hint = this.$message({
                message: `${this.$t("anti_gs1_tan.message_load")}`,
                type: 'warning',
                showClose: true,
                duration: 0,
            });
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let rec_id = this.details.rec_id;
            let index = this.details.index;
            let msgtype = this.details.msgtype;
            this.$axios
                .get("/api/adm/cgi/readmsg.cgi", {
                    params: {
                        __mode: "showdigest",
                        index: index,
                        sid: sid,
                        rec_id: rec_id,
                        is_elk: 0,
                        msgtype: msgtype,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res)
                    setTimeout(() => {
                        close_hint.close()
                    })
                    this.readmsg_disabled = 1

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        this.$message({
                            showClose: true,
                            message: `${res.data.fmstatus.errmsg}`,
                            type: "error",
                        });
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.abstract1 = res.data.ret.DIGEST;
                        this.abstract2 = true;
                    }
                    // console.log( this.html)
                })
                .catch((err) => {
                    // console.log("接口错误");
                    console.log(err);
                    // alert(err);
                });
        },
        // 正文分析
        matter_show_two_database() {
            this.readmsg_disabled = 0
            const close_hint = this.$message({
                message: `${this.$t("anti_gs1_tan.message_load")}`,
                type: 'warning',
                showClose: true,
                duration: 0,
            });
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let rec_id = this.details.rec_id;
            let index = this.details.index;
            let msgtype = this.details.msgtype;
            this.$axios
                .get("/api/adm/cgi/readmsg.cgi", {
                    params: {
                        __mode: "printnumemail",
                        index: index,
                        sid: sid,
                        rec_id: rec_id,
                        is_elk: 0,
                        msgtype: msgtype,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res);
                    setTimeout(() => {
                        close_hint.close()
                    });
                    this.readmsg_disabled = 1;

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        this.$message({
                            showClose: true,
                            message: `${res.data.fmstatus.errmsg}`,
                            type: "error",
                        });
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.matter1 = res.data.ret.DETAIL;
                        this.matter2 = true;
                    }
                })
                .catch((err) => {
                    // console.log("接口错误");
                    console.log(err);
                    // alert(err);
                });
        },
        // 原始正文

        originol_show_to_database() {
            this.readmsg_disabled = 0;
            const close_hint = this.$message({
                message: `${this.$t("anti_gs1_tan.message_load")}`,
                type: 'warning',
                showClose: true,
                duration: 0,
            });
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let rec_id = this.details.rec_id;
            let index = this.details.index;
            let msgtype = this.details.msgtype;
            this.$axios
                .get("/api/adm/cgi/readmsg.cgi", {
                    params: {
                        __mode: "printoriginalbody",
                        index: index,
                        sid: sid,
                        rec_id: rec_id,
                        is_elk: 0,
                        msgtype: msgtype,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res);
                    setTimeout(() => {
                        close_hint.close()
                    });
                    this.readmsg_disabled = 1;
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        this.$message({
                            showClose: true,
                            message: `${res.data.fmstatus.errmsg}`,
                            type: "error",
                        });
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.original1 = res.data.ret.ORIG_BODY;
                        this.original2 = true;

                    }
                })
                .catch((err) => {
                    // console.log("接口错误");
                    console.log(err);
                    // alert(err);
                });
        },
        // 分词信息
        print_show_two_database() {
            this.readmsg_disabled = 0;
            const close_hint = this.$message({
                message: `${this.$t("anti_gs1_tan.message_load")}`,
                type: 'warning',
                showClose: true,
                duration: 0,
            });
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let rec_id = this.details.rec_id;
            let index = this.details.index;
            let msgtype = this.details.msgtype;

            this.$axios
                .get("/api/adm/cgi/readmsg.cgi", {
                    params: {
                        __mode: "printparticipleinfo",
                        index: index,
                        sid: sid,
                        rec_id: rec_id,
                        is_elk: 0,
                        msgtype: msgtype,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res,'111111111111')
                    setTimeout(() => {
                        close_hint.close()
                    });
                    this.readmsg_disabled = 1;
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        this.$message({
                            showClose: true,
                            message: `${res.data.fmstatus.errmsg}`,
                            type: "error",
                        });
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.print1 = res.data.ret.PAETICIPLE_INFO;
                        this.print2 = true;

                    }
                })
                .catch((err) => {
                    // console.log("接口错误");
                    console.log(err);
                    // alert(err);
                });
        },
        // 原因分析

        reason_show_to_database() {
            this.readmsg_disabled = 0;
            const close_hint = this.$message({
                message: `${this.$t("anti_gs1_tan.message_load")}`,
                type: 'warning',
                showClose: true,
                duration: 0,
            });
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let rec_id = this.details.rec_id;
            let index = this.details.index;
            let msgtype = this.details.msgtype;
            this.$axios
                .get("/api/adm/cgi/readmsg.cgi", {
                    params: {
                        __mode: "view_reason",
                        index: index,
                        sid: sid,
                        rec_id: rec_id,
                        is_elk: 0,
                        msgtype: msgtype,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                    setTimeout(() => {
                        close_hint.close()
                    });
                    this.readmsg_disabled = 1;
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        this.$message({
                            showClose: true,
                            message: `${res.data.fmstatus.errmsg}`,
                            type: "error",
                        });
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.reason1 = res.data.ret.REASON;
                        this.reason2 = true;

                    }
                })
                .catch((err) => {
                    // console.log("接口错误");
                    console.log(err);
                    // alert(err);
                });
        },

        // elk
        // 原始正文

        originol_show_to_elk() {
            this.readmsg_disabled = 0;
            const close_hint = this.$message({
                message: `${this.$t("anti_gs1_tan.message_load")}`,
                type: 'warning',
                showClose: true,
                duration: 0,
            });
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let rec_id = this.details.rec_id;
            let index = this.details.index;
            let msgtype = this.details.msgtype;
            this.$axios
                .get("/api/adm/cgi/readmsg.cgi", {
                    params: {
                        __mode: "printoriginalbody",
                        index: index,
                        sid: sid,
                        rec_id: rec_id,
                        is_elk: 1,
                        msgtype: msgtype,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res);
                    setTimeout(() => {
                        close_hint.close()
                    });
                    this.readmsg_disabled = 1;
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        this.$message({
                            showClose: true,
                            message: `${res.data.fmstatus.errmsg}`,
                            type: "error",
                        });
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.original1 = res.data.ret.ORIG_BODY;
                        this.original2 = true;

                    }
                })
                .catch((err) => {
                    // console.log("接口错误");
                    console.log(err);
                    // alert(err);
                });
        },
        // 分词信息
        print_show_two_elk() {
            this.readmsg_disabled = 0;
            const close_hint = this.$message({
                message: `${this.$t("anti_gs1_tan.message_load")}`,
                type: 'warning',
                showClose: true,
                duration: 0,
            });
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let rec_id = this.details.rec_id;
            let index = this.details.index;
            let msgtype = this.details.msgtype;

            this.$axios
                .get("/api/adm/cgi/readmsg.cgi", {
                    params: {
                        __mode: "printparticipleinfo",
                        index: index,
                        sid: sid,
                        rec_id: rec_id,
                        is_elk: 1,
                        msgtype: msgtype,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    //   console.log(res,'111111111111')
                    setTimeout(() => {
                        close_hint.close()
                    });
                    this.readmsg_disabled = 1;
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        this.$message({
                            showClose: true,
                            message: `${res.data.fmstatus.errmsg}`,
                            type: "error",
                        });
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.print1 = res.data.ret.PAETICIPLE_INFO;
                        this.print2 = true;

                    }
                })
                .catch((err) => {
                    // console.log("接口错误");
                    console.log(err);
                    // alert(err);
                });
        },
        // 正文分析
        matter_show_two_elk() {
            this.readmsg_disabled = 0;
            const close_hint = this.$message({
                message: `${this.$t("anti_gs1_tan.message_load")}`,
                type: 'warning',
                showClose: true,
                duration: 0,
            });
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let rec_id = this.details.rec_id;
            let index = this.details.index;
            let msgtype = this.details.msgtype;
            this.$axios
                .get("/api/adm/cgi/readmsg.cgi", {
                    params: {
                        __mode: "printnumemail",
                        index: index,
                        sid: sid,
                        rec_id: rec_id,
                        is_elk: 1,
                        msgtype: msgtype,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res);
                    setTimeout(() => {
                        close_hint.close()
                    });
                    this.readmsg_disabled = 1;
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        this.$message({
                            showClose: true,
                            message: `${res.data.fmstatus.errmsg}`,
                            type: "error",
                        });
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.matter1 = res.data.ret.DETAIL;
                        this.matter2 = true;

                    }
                })
                .catch((err) => {
                    // console.log("接口错误");
                    console.log(err);
                    // alert(err);
                });
        },
        // 显示摘要
        abstract_show_tow_elk() {
            this.readmsg_disabled = 0;
            const close_hint = this.$message({
                message: `${this.$t("anti_gs1_tan.message_load")}`,
                type: 'warning',
                showClose: true,
                duration: 0,
            });
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let rec_id = this.details.rec_id;
            let index = this.details.index;
            let msgtype = this.details.msgtype;
            this.$axios
                .get("/api/adm/cgi/readmsg.cgi", {
                    params: {
                        __mode: "showdigest",
                        index: index,
                        sid: sid,
                        rec_id: rec_id,
                        is_elk: 1,
                        msgtype: msgtype,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                    setTimeout(() => {
                        close_hint.close()
                    });
                    this.readmsg_disabled = 1;
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        this.$message({
                            showClose: true,
                            message: `${res.data.fmstatus.errmsg}`,
                            type: "error",
                        });
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.abstract1 = res.data.ret.DIGEST;
                        this.abstract2 = true;

                    }
                    // console.log( this.html)
                })
                .catch((err) => {
                    // console.log("接口错误");
                    console.log(err);
                    // alert(err);
                });
        },
        // 原因分析

        reason_show_to_elk() {
            this.readmsg_disabled = 0;
            const close_hint = this.$message({
                message: `${this.$t("anti_gs1_tan.message_load")}`,
                type: 'warning',
                showClose: true,
                duration: 0,
            });
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let rec_id = this.details.rec_id;
            let index = this.details.index;
            let msgtype = this.details.msgtype;
            this.$axios
                .get("/api/adm/cgi/readmsg.cgi", {
                    params: {
                        __mode: "view_reason",
                        index: index,
                        sid: sid,
                        rec_id: rec_id,
                        is_elk: 1,
                        msgtype: msgtype,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                    setTimeout(() => {
                        close_hint.close()
                    });
                    this.readmsg_disabled = 1;
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        this.$message({
                            showClose: true,
                            message: `${res.data.fmstatus.errmsg}`,
                            type: "error",
                        });
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.reason1 = res.data.ret.REASON;
                        this.reason2 = true;

                    }
                })
                .catch((err) => {
                    // console.log("接口错误");
                    console.log(err);
                    // alert(err);
                });
        },
    }
}